import script from "./new-edit-marketing-email-items-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-edit-marketing-email-items-modal.vue?vue&type=script&setup=true&lang=ts"

import "./new-edit-marketing-email-items-modal.vue?vue&type=style&index=0&id=e579f282&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e579f282"]])

export default __exports__